import { render, staticRenderFns } from "./UserAvatarMenu.vue?vue&type=template&id=613e85b7&"
import script from "./UserAvatarMenu.vue?vue&type=script&lang=js&"
export * from "./UserAvatarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports